function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 12a5 5 0 10-5-5 5 5 0 005 5zm0-7a2 2 0 11-2 2 2.002 2.002 0 012-2zM13.829 16.049a9.34 9.34 0 003.15-1.224 1.4 1.4 0 10-1.485-2.374 6.716 6.716 0 01-6.883.064 1.4 1.4 0 00-1.441 2.401 9.35 9.35 0 003 1.133L7.01 19.21a1.4 1.4 0 101.98 1.98L12 18.18l3.01 3.01a1.4 1.4 0 101.98-1.98z"
});
function SvgOk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 21",
    height: "1em",
    viewBox: "0 0 24 24",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgOk;